// extracted by mini-css-extract-plugin
module.exports = {"CovenantsMainBox":"covenants-sections_CovenantsMainBox__-b8i1","CovenantsMainBox0":"covenants-sections_CovenantsMainBox0__1Hyh0"};